export const classNameUtils = {
  cardVariants: (variant) => {
    const variantsMap = {
      "customMenu": {
        header: "bg-[#031B35]!",
        title: "text-white! text-[18px]!",
        bodyBase: "flex-1 min-h-0 bg-linear-to-b from-white to-[#EDF6FF]!",
        body: "flex-1 min-h-0 py-4! px-7! bg-linear-to-b from-white to-[#EDF6FF]!",
      }
    };

    return variantsMap[variant] || variantsMap["default"];
  }
};